import React, { useState, useEffect } from 'react';
import { 
  Card, 
  Form, 
  Input, 
  Button, 
  message,
  Typography,
  Avatar,
  Spin
} from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import PageLayout from '../../../components/layout/PageLayout';
import masterService from '../../../services/masterService';
import { useUser } from '../../../context/UserContext';

const { Title, Text } = Typography;
const { TextArea } = Input;

const AboutUs = () => {
  const { user } = useUser();
  const [form] = Form.useForm();
  
  // State management
  const [loading, setLoading] = useState(false);
  const [spinning, setSpinning] = useState(true);

  // Load about us data
  useEffect(() => {
    getAboutUs();
  }, []);

  const getAboutUs = async () => {
    try {
      setSpinning(true);
      const response = await masterService.getAboutUs();
      
      if (response.data && response.data.status) {
        form.setFieldsValue({
          about_us_text: response.data.data
        });
      } else {
        message.error('Failed to fetch about us content');
      }
    } catch (error) {
      console.error('Error fetching about us:', error);
      message.error('Failed to fetch about us content');
    } finally {
      setSpinning(false);
    }
  };

  // Handle form submission
  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      
      const response = await masterService.updateAboutUs(values);
      
      if (response.data && response.data.status) {
        message.success(response.data.message || 'About Us saved successfully!');
      } else {
        message.error(response.data.message || 'Failed to save about us');
      }
    } catch (error) {
      console.error('Error saving about us:', error);
      message.error('Failed to save about us');
    } finally {
      setLoading(false);
    }
  };

  // Header content with user info
  const headerContent = (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
        <Avatar 
          src={user?.avatar} 
          size={64} 
          style={{ marginRight: '16px' }}
        >
          {user?.name?.charAt(0)?.toUpperCase()}
        </Avatar>
        <div>
          <Title level={4} style={{ margin: 0, marginBottom: '4px' }}>
            {user?.name || 'Admin'}
          </Title>
          <Text type="secondary">Manage About Us Content</Text>
        </div>
      </div>
    </div>
  );

  return (
    <PageLayout
      title="About Us"
      desc="Manage about us content"
      avatar={user?.avatar}
      headerContent={headerContent}
    >
      <Spin spinning={spinning}>
        <Card>
          <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
            style={{ maxWidth: '100%' }}
          >
            <Form.Item
              label="About Us Content"
              name="about_us_text"
              rules={[
                { required: true, message: 'Please enter about us content' }
              ]}
            >
              <TextArea
                rows={15}
                placeholder="Enter about us content here..."
                style={{ minHeight: '400px' }}
              />
            </Form.Item>

            <Form.Item style={{ marginBottom: 0 }}>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                icon={<SaveOutlined />}
                size="large"
              >
                Save About Us
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    </PageLayout>
  );
};

export default AboutUs;